import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teacher-register',
  templateUrl: './teacher-register.component.html',
  styleUrls: ['./teacher-register.component.scss']
})
export class TeacherRegisterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
